import VueI18n from "vue-i18n"
import Vue from "vue"

import en from "./en.json"
import de from "./de.json"
import fr from "./fr.json"
import nl from "./nl.json"

import store from "../store"

Vue.use(VueI18n)

const messages = {
  en,
  de,
  fr,
  nl,
}
// get first URL segment
const locale = window.location.pathname.split("/")[1]

store.commit("setLanguage", locale)

console.log({ locale })

export default new VueI18n({
  locale: locale ?? "en",
  messages,
  fallbackLocale: "en",
})
